module.exports = __webpack_public_path__ + "static/media/logo-footer.318727ec.svg";